<template>
  <footer class="content-block section-padding pb-14!">
    <div class="mx-auto w-full">
      <div class="md:flex md:justify-between">
        <div class="mb-14 md:mb-0">
          <router-link to="/" class="flex items-center">
            <img src="/images/emojis/ice-cream.svg" class="h-7 mr-2" alt="Ice Cream Emoji" />
            <span class="self-center text-2xl font-semibold whitespace-nowrap">Fitsnack</span>
          </router-link>
        </div>
        <div class="grid grid-cols-2 gap-14 md:gap-24 sm:grid-cols-3">
          <div>
            <h3 class="footer-title text-gray-900">Let's connect</h3>
            <ul class="footer-links">
              <li>
                <a href="https://www.producthunt.com/posts/fitsnack" target="_blank"
                  >Product Hunt</a
                >
              </li>
              <li>
                <a href="https://www.strava.com/clubs/fitsnack" target="_blank">Strava club</a>
              </li>
              <li>
                <a href="mailto:fitpowerapp@gmail.com?subject=Report%20a%20bug" target="_blank"
                  >Report a bug</a
                >
              </li>
              <li>
                <a href="mailto:fitpowerapp@gmail.com?subject=Request%20a%20feature" target="_blank"
                  >Request a feature</a
                >
              </li>
            </ul>
          </div>

          <div>
            <h3 class="footer-title">Attribution</h3>
            <ul class="footer-links">
              <li>
                <a href="https://github.com/twitter/twemoji" target="_blank">Twemoji</a>
              </li>
              <li>
                <a href="https://googlefonts.github.io/noto-emoji-animation/" target="_blank"
                  >Animated Emoji</a
                >
              </li>
              <li>
                <a href="https://lucide.dev/" target="_blank">Lucide</a>
              </li>
            </ul>
          </div>

          <div>
            <h3 class="footer-title">Other Links</h3>
            <ul class="footer-links">
              <li>
                <a href="https://strava.com/" target="_blank">Strava</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="my-14 border-gray-200 sm:mx-auto" />
      <div class="flex flex-col items-center sm:flex-row sm:items-center sm:justify-between">
        <span class="text-sm text-gray-500 sm:text-center"
          >© {{ currYear }} Fitsnack. All Rights Reserved.
        </span>
        <div class="flex mt-4 sm:justify-center sm:mt-0">
          <a href="https://strava.com" target="_blank">
            <img
              src="/images/strava/api_logo_pwrdBy_strava_horiz_light.svg"
              class="h-7"
              alt="Powered by Strava Logo"
            />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const currYear = new Date().getFullYear()
</script>

<style scoped>
@reference "../assets/css/base.css";

.footer-title {
  @apply mb-6 text-sm font-semibold text-gray-900 uppercase;
}

.footer-links {
  @apply text-gray-500 flex flex-col gap-y-4;
}

.footer-links a {
  @apply hover:underline;
}
</style>
